import React, { useState, useRef } from "react";
import { Button } from "reactstrap";

const Header = () => {
  window.addEventListener("scroll", handleScroll, true);
  const calloutRef = useRef();
  let opacity = 100;
  function handleScroll() {
    calloutRef.current.style.opacity = opacity + "%";
    opacity -= 10;
  }

  return (
    <div id="header" onScroll={() => console.log("scroll")}>
      <img className="lockup" src="/img/lockup.svg" alt="hall of heroes" />
      <img className="lockup-img" src="/img/eli.png" alt="statue" />
      <h3 className="callout" ref={calloutRef}>
        Scroll down to explore
      </h3>
    </div>
  );
};

export default Header;
